import { action, makeObservable, observable } from 'mobx'

import Workflow from '~/client/src/shared/models/Workflow'
import CompaniesStore from '~/client/src/shared/stores/domain/Companies.store'
import DesktopInitialState, {
  IFilters,
} from '~/client/src/shared/stores/InitialState'
import BaseLogisticsMapStore from '~/client/src/shared/stores/ui/BaseLogisticsMap.store'
import {
  createFilterValueByType,
  getSelectedFilterValues,
} from '~/client/src/shared/utils/logisticsHelper'
import { UNASSIGNED } from '~/client/src/shared/utils/ZoneLevelLocationConstants'

import LogisticsStore from '../Logistics/Logistics.store'

export default class LogisticsMapStore extends BaseLogisticsMapStore {
  @observable private _allForms: Workflow[] = []
  public constructor(
    private readonly desktopStore: LogisticsStore,
    companiesStore: CompaniesStore,
    private readonly state: DesktopInitialState,
  ) {
    super(desktopStore, companiesStore)
    makeObservable(this)
  }

  public get allForms(): Workflow[] {
    return this._allForms
  }

  @action.bound
  public setAllForms(forms: Workflow[]) {
    this._allForms = forms
  }

  protected get filter(): IFilters {
    return this.desktopStore.filters
  }

  protected get formsByCreationDate(): Workflow[] {
    return this.allForms.slice().sort((a, b) => b.createdAt - a.createdAt)
  }

  public getFilteredCollectionExcludeFilter = (
    excludedFilters: Array<string> = [],
  ) => {
    let filteredCollection = this.isSearchFilterActive
      ? this.instancesInPeriodInterval.filter(this.searchFiltering)
      : this.instancesInPeriodInterval

    this.activeFilterTypes.forEach(filterType => {
      const shouldUseFilter = !excludedFilters.includes(filterType)

      if (!shouldUseFilter) {
        return
      }

      const filter = this.filter.fieldsMap[filterType]
      const { initialFilterOptions } = filter
      const selectedValues = getSelectedFilterValues(
        filterType,
        initialFilterOptions,
      )

      filteredCollection = filteredCollection.filter(inst => {
        const valueGetter = this.filterValueByType[filterType]
        const value = valueGetter(inst)

        if (initialFilterOptions.has(UNASSIGNED) && !value.length) {
          return true
        }

        return value.some(v => selectedValues.has(v))
      })
    })

    return filteredCollection
  }

  private get filterValueByType() {
    return createFilterValueByType(
      this.store.getSharedFormById,
      () => this.state.activeProject.id,
    )
  }
}
